export const glassTheme = {
  backgrounds: {
    page: {
      image: 'https://cdn.nexastaff.ai/back.jpg',
      overlay: 'rgba(14, 44, 55, 0.92)',
      overlayGradient: 'linear-gradient(135deg, rgba(14, 44, 55, 0.92) 0%, rgba(22, 69, 85, 0.92) 100%)'
    },
    sections: {
      mentor: {
        background: 'rgba(0, 0, 0, 0.6)',
        blur: '1px',
        opacity: 1,
        border: 'rgba(255, 255, 255, 0)'
      },
      revenue: {
        background: 'rgba(1, 120, 153, 0.44)',
        blur: '5px',
        opacity: 1,
        border: 'rgba(0, 198, 255, 0.1)'
      },
      form: {
        background: 'rgba(255, 255, 255, 0.58)',
        blur: '5px',
        opacity: 1,
        border: 'rgba(255, 255, 255, 0.1)'
      }
    },
    cards: {
      option: {
        background: 'rgba(255, 255, 255, 0.09)',
        blur: '10px',
        opacity: 1,
        border: 'rgba(255, 255, 255, 0.13)'
      },
      calculator: {
        background: 'rgba(0, 0, 0, 0.23)',
        blur: '50px',
        opacity: 1,
        border: 'rgba(255, 255, 255, 0.1)',
        shadow: '0 8px 32px rgba(0, 0, 0, 0.5)'
      },
      form: {
        background: 'rgba(0, 0, 0, 0.44)',
        blur: '10px',
        border: 'rgba(255, 255, 255, 0.1)',
        shadow: '0 8px 32px rgba(0, 0, 0, 0.3)'
      },
      input: {
        background: 'rgba(0, 0, 0, 0.18)',
        focusBackground: 'rgba(0, 0, 0, 0.3)',
        border: 'rgba(255, 255, 255, 0.1)',
        focusBorder: 'rgba(0, 198, 255, 0.5)',
        shadow: '0 0 20px rgba(0, 198, 255, 0.2)'
      },
      result: {
        background: 'rgba(5, 1, 60, 0.29)',
        border: 'rgba(0, 198, 255, 0.2)'
      }
    },
    labels: {
      full: {
        background: 'rgba(87, 90, 21, 0.6)',
        color: '#34D399',
        border: 'rgba(52, 211, 153, 0.4)',
        blur: '20px'
      },
      quarter: {
        background: 'rgba(52, 53, 132, 0.6)',
        color: '#818CF8',
        border: 'rgba(99, 102, 241, 0.4)',
        blur: '20px'
      }
    },
    footer: {
      background: 'rgba(0, 0, 0, 0.85)',
      border: 'rgba(255, 255, 255, 0.1)'
    },
    titles: {
      gradient: 'linear-gradient(135deg, #FFFFFF 0%, #00C6FF 100%)'
    }
  }
}; 